function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#6373A4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.589 15.884a3.15 3.15 0 01-.51-.175l-2.74 2.74a1.972 1.972 0 01-2.789-2.788l4.184-4.184c.181-.184.4-.327.641-.418a.734.734 0 01.244-.09 1.35 1.35 0 01.342-.064c.266-.023.534.008.788.09.29.101.555.266.774.482.184.18.328.396.425.635.014 0 .035-.007.05-.007a.965.965 0 00.57-.28l.956-.955a4.037 4.037 0 00-.606-.787 3.934 3.934 0 00-1.974-1.067.813.813 0 00-.265-.042 2.153 2.153 0 00-.237-.028 1.585 1.585 0 00-.362-.014 3.84 3.84 0 00-.495.035h-.014l-.196.028a4.468 4.468 0 00-1.025.355 3.888 3.888 0 00-1.01.733l-4.184 4.183a3.944 3.944 0 005.578 5.578l3.835-3.835a4.995 4.995 0 01-1.98-.125z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.844 4.156a3.943 3.943 0 00-5.578 0L10.431 7.99a5.023 5.023 0 012.503.286l2.727-2.727a1.972 1.972 0 112.789 2.79l-2.727 2.726-.39.39-.398.398-.669.669a1.935 1.935 0 01-1.68.55 1.536 1.536 0 01-.474-.125c-.48-.2-.86-.58-1.06-1.06a.987.987 0 00-.62.286l-.956.956a3.857 3.857 0 001.862 1.624c.165.077.338.138.516.181a3.937 3.937 0 003.507-.746l.007-.007c.097-.083.202-.174.293-.265l.348-.348 3.835-3.835a3.943 3.943 0 000-5.578z"
}));

function SvgChainlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgChainlink;